"use strict";

var cov_f66nybcda = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\core\\index.js";
  var hash = "ba6ebef5332d6a53d8062912fb6ceec53c8cd8d4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\core\\index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "ba6ebef5332d6a53d8062912fb6ceec53c8cd8d4"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _langnames = require("./langnames");

Object.keys(_langnames).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _langnames[key];
    }
  });
});

var _languageDetection = require("./language-detection");

Object.keys(_languageDetection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _languageDetection[key];
    }
  });
});

var _resources = require("./resources");

Object.keys(_resources).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _resources[key];
    }
  });
});